import React, { useEffect, useState } from "react";
import loadable from "@loadable/component";
import APIS from "../../contants/Endpoints";
import useGetHook from "../../customHooks/useGetHook";
import { useParams } from "react-router-dom";
import usePatchHook from "../../customHooks/usePatchHook";
import Spinner from "../../components/Reuseable/Spinner";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { categoryFormValidation } from "../../utils/formValidation";
const EditCategoryComponent = loadable(
  () => import("../../components/Category/EditCategory")
);
type Props = {};

const EditCategory = (props: Props) => {
  const { id } = useParams();
  const { mutateAsync } = usePatchHook({
    queryKey: ["category", `category-${id}`],
    navigateURL: "/category",
  });

  const { data: singleCategory, isPending: singleCategoryLoading } = useGetHook(
    {
      queryKey: [`category-${id}`],
      url: `${APIS.CATEGORY}${id}/`,
      params: {},
    }
  );

  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
    reset,
  } = useForm({
    resolver: yupResolver(categoryFormValidation),
    defaultValues: {
      name: "",
      code: "",
    },
  });

  const handleCategoryUpdate = async (values: any) => {
    const url = `${APIS.CATEGORY}${id}/`;
    const formData = {
      name: values.name,
      code: values.code,
    };
    try {
      await mutateAsync({ url, formData, setError });
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    if (singleCategory) {
      reset({
        name: singleCategory.name,
        code: singleCategory.code,
      });
    }
  }, [singleCategory, reset]);

  return (
    <>
      {singleCategoryLoading ? (
        <Spinner />
      ) : (
        <EditCategoryComponent
          handleCategoryUpdate={handleCategoryUpdate}
          singleCategory={singleCategory}
          register={register}
          handleSubmit={handleSubmit}
          errors={errors}
        />
      )}
    </>
  );
};

export default EditCategory;
